import { Dayjs } from "dayjs"
import { ICase, ICaseFields } from "./case.type"
import { Status } from "@/types/Status"
import { statusMap } from "@/constants/awsConnectCases"

export class Case implements ICase {
  constructor(
    public id: number,
    public externalId: string,
    public fields: Partial<ICaseFields>,
    public createdAt: Dayjs,
    public updatedAt: Dayjs,
  ) {}

  get status(): Status {
    const fallbackStatus = ["critical", "Unknown"]
    const [type, label] =
      statusMap[(this.fields?.status ?? "").toLowerCase()] || fallbackStatus
    return new Status(type, label)
  }
}
